import React, { useState } from "react";
import axios from "axios";
import {
  Box,
  Flex,
  Button,
  FormControl,
  FormLabel,
  Input,
  Text,
  useToast,
  Heading,
  useColorModeValue,
} from "@chakra-ui/react";
import { useHistory } from "react-router-dom";
import config from "config";

function RequestPasswordReset() {
  const [email, setEmail] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState(null);
  const [successMessage, setSuccessMessage] = useState(null);
  const [showGoHomeButton, setShowGoHomeButton] = useState(false); // New state for Go Home button
  const toast = useToast();
  const history = useHistory();

  const handleRequestReset = async () => {
    setIsSubmitting(true);
    setError(null);
    setSuccessMessage(null);

    try {
      const url = config.URL;
      console.log(email);
      const response = await axios.post(`${config.API_URL}/auth/request-password-reset`, {
        email, url,
      });

      if (response.status === 200) {
        setSuccessMessage("Password reset email sent successfully. Please check your inbox.");
        setShowGoHomeButton(true); // Show the Go Home button
        toast({
          title: "Success",
          description: "Password reset email sent successfully.",
          status: "success",
          duration: 5000,
          isClosable: true,
        });
      }
    } catch (error) {
      setError("Failed to send reset email. Please check the email address and try again.");
      toast({
        title: "Error",
        description: "Failed to send reset email.",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  // Navigate to the home page when the Go Home button is clicked
  const goHome = () => {
    history.push("/"); // Redirect to the home page
  };

  // Color mode values
  const formBg = useColorModeValue("white", "gray.800");
  const formColor = useColorModeValue("gray.800", "white");
  const buttonColor = useColorModeValue("teal", "teal");
  const errorColor = useColorModeValue("red.500", "red.300");
  const successColor = useColorModeValue("green.500", "green.300");
  const pageBg = useColorModeValue("gray.100", "gray.900");

  return (
    <Flex align="center" justify="center" height="100vh" bg={pageBg}>
      <Box bg={formBg} color={formColor} p="6" rounded="md" shadow="lg" width="100%" maxW="400px">
        <Heading as="h3" size="lg" mb="4" textAlign="center">
          Request Password Reset
        </Heading>

        {/* Conditionally render form or Go Home button */}
        {!showGoHomeButton ? (
          <FormControl>
            <FormLabel>Email Address</FormLabel>
            <Input
              type="email"
              placeholder="Enter your email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              mb="4"
            />
            {error && <Text color={errorColor}>{error}</Text>}
            {successMessage && <Text color={successColor}>{successMessage}</Text>}
            <Button
              colorScheme={buttonColor}
              width="100%"
              onClick={handleRequestReset}
              isLoading={isSubmitting}
              isDisabled={!email}
            >
              Send Reset Email
            </Button>
          </FormControl>
        ) : (
          <Button
            colorScheme="blue"
            width="100%"
            onClick={goHome}
            mt="4"
          >
            Go Home
          </Button>
        )}
      </Box>
    </Flex>
  );
}

export default RequestPasswordReset;
